import { space } from '../spacing.js';
import { colors } from '../colors.js';
import { opacity } from '../opacity.js';
import { sizes } from '../sizing.js';
import { transitions } from '../transition.js';
import { paragraphs } from './paragraphs.js';
export const baseToggle = {
    marginRight: space.x2,
    gap: space.x1,
    transition: {
        timingFunction: transitions.easing['ease-out'],
        property: transitions.property.common,
        duration: transitions.duration.fast,
    },
    defaultState: {
        onColor: colors.controls.primary,
        offColor: colors.borders.form,
    },
};
export const toggleKnob = {
    padding: space.x_5,
    color: colors.backgrounds.onGray,
    sizeStandard: sizes.x5,
    sizeLarge: sizes.x7,
};
export const toggleLabel = paragraphs.compact;
export const toggleStates = {
    hover: {
        onColor: colors.controls.primaryHover,
    },
    pressed: {
        onColor: colors.controls.primaryActive,
    },
    focus: {},
    disabled: {
        opacity: opacity.faded,
    },
    loading: {},
};
//# sourceMappingURL=toggle.js.map